import { PencilIcon } from '@heroicons/react/solid';
import { t } from '@nodal/i18n';
import { forwardRef } from 'react';

import type { ProfileCardProps } from './ProfileCard.interface';

export const ProfileCard = forwardRef<HTMLDivElement, ProfileCardProps>(
  ({ title, subTitle, edit, children, className = '' }, ref) => (
    <div
      className={`flex flex-col col-span-12 col-start-2 gap-6 justify-start p-4 sm:p-8 w-full bg-white rounded-lg ${className}`}
      ref={ref}
    >
      <div className="flex justify-between items-center">
        {title === 'Identity Verification' && (
          <div className="flex flex-1 justify-between items-center">
            <h3 className="text-xl font-semibold leading-7 text-grey-forest-900">
              {title}
            </h3>
            <div className="py-1 px-3 text-sm font-medium text-forest-500 bg-gray-100 rounded-full">
              Viewable by Nodal Staff only
            </div>
          </div>
        )}

        {title === 'Insurance Review' && (
          <>
            <div className="flex flex-col gap-2">
              <div className="flex flex-1 justify-between items-center">
                <h3 className="text-xl font-semibold leading-7 text-grey-forest-900">
                  {title}
                </h3>
                <div className="py-1 px-3 text-sm font-medium text-forest-500 bg-gray-100 rounded-full">
                  Viewable by Nodal Staff only
                </div>
              </div>
              <div className="px-3 pt-3">
                <p className="text-grey-forest-700">
                  We need to collect some additional information from you in
                  order to review your current health insurance coverage. Please
                  follow the prompts by clicking below.
                </p>
              </div>
              <div className="flex justify-center">
                <button
                  onClick={() => edit && edit(title, subTitle)}
                  type="button"
                  className="inline-flex justify-center items-center py-2 px-4 text-sm font-medium text-white bg-forest-500 hover:bg-forest-400 rounded-xl border border-transparent focus:outline-none focus:ring-2 focus:ring-forest-500 focus:ring-offset-2 shadow-sm sm:text-base"
                >
                  Complete Insurance Review
                </button>
              </div>
            </div>
          </>
        )}

        {title !== 'Identity Verification' && title !== 'Insurance Review' && (
          <h3 className="text-xl font-semibold leading-7 text-grey-forest-900">
            {title}
          </h3>
        )}
        {edit &&
          title !== 'Identity Verification' &&
          title !== 'Insurance Review' && (
            <button
              onClick={() => edit(title, subTitle)}
              type="button"
              className="flex gap-2 justify-between items-center px-3"
            >
              <PencilIcon className="w-5 h-5 text-forest-400 sm:w-4 sm:h-4" />
              <p className="hidden text-sm font-medium leading-4 text-forest-500 sm:block">
                {t('Edit')}
              </p>
            </button>
          )}
      </div>
      {children}
    </div>
  ),
);

ProfileCard.displayName = 'ProfileCard';
